<template>
  <section class="hist-wrap">
    <FormSpinner v-if="loading" full />

    <div v-else>
      <div v-if="erro" class="muted">{{ erro }}</div>

      <div v-else>
        <header class="hist-header">
          <h4>Histórico da Matrícula</h4>
          <small v-if="items.length">{{ items.length }} registro<span v-if="items.length !== 1">s</span></small>
        </header>

        <div v-if="!items.length" class="muted">Sem registros para exibir</div>

        <ul v-else class="hist-list">
          <li v-for="(h, i) in items" :key="i">
            <div class="when">
              <strong>{{ formatDateTime(h.dataHistorico) }}</strong>
              <small class="id">ID Mat.: {{ h.idMatricula }}</small>
            </div>

            <div class="what">
            <div class="line">
              <div class="flow">
                <span class="tag" :class="situacaoBadge(h.situacaoAnterior)">{{ h.situacaoAnterior || '—' }}</span>
                <span class="arrow">→</span>
                <span class="tag" :class="situacaoBadge(h.situacaoNova)">{{ h.situacaoNova || '—' }}</span>
              </div>

              <div class="meta" v-if="h.pessoa || h.clientIp">
                <span v-if="h.pessoa">Por: {{ h.pessoa }}</span>
                <span v-if="h.clientIp">IP: {{ h.clientIp }}</span>
              </div>
            </div>

            <p v-if="h.observacao" class="obs">{{ h.observacao }}</p>
            </div>
          </li>
        </ul>
      </div>

      <footer class="hist-footer">
        <button class="btn btn-secondary" @click="$emit('close')">Fechar</button>
      </footer>
    </div>
  </section>
</template>

<script>
import MatriculaService from '@/services/matricula.service.js'
import FormSpinner from '@/components/utilities/FormSpinner.vue'
import { formatDate } from '@/services/utils.service.js'

export default {
  name: 'HistoricoMatricula',
  components: { FormSpinner },
  props: {
    idMatricula: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      loading: false,
      erro: null,
      items: []
    }
  },
  methods: {
    formatDate (d) { return formatDate(d) },
    formatDateTime (dt) {
      if (!dt) return '--'
      const [d, t] = String(dt).split(' ')
      const hhmm = t ? t.slice(0,5) : ''
      return `${this.formatDate(d)} ${hhmm}`
    },
    situacaoBadge (s) {
      if (!s) return 'status_inativo'
      const map = {
        'Ativo': 'status_ativo',
        'Matrícula Pendente': 'status_matricula',
        'Proposta-Rematrícula': 'status_rematricula'
      }
      return map[s] || 'status_inativo'
    },
    normalize (row) {
      return {
        idMatricula: row?.idMatricula,
        dataHistorico: row?.dataHistorico,
        situacaoAnterior: row?.situacaoAnterior ?? null,
        situacaoNova: row?.situacaoNova ?? null,
        pessoa: row?.pessoa ?? null,
        clientIp: row?.clientIp ?? null,
        observacao: row?.observacao ?? null
      }
    },
    async load () {
      this.loading = true
      this.erro = null
      this.items = []
      try {
        const { data } = await MatriculaService.getHistoricoMatricula(this.idMatricula)
        const list = Array.isArray(data?.data) ? data.data.map(this.normalize) : []
        // garante ordem desc por dataHistorico
        this.items = list.sort((a, b) => new Date(b.dataHistorico) - new Date(a.dataHistorico))
      } catch (e) {
        this.erro = 'Não foi possível carregar o Histórico'
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    idMatricula (val, old) {
      if (val && val !== old) this.load()
    }
  }
}
</script>

<style lang="scss" scoped>
.hist-wrap {
  padding: $hmg
}

.hist-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: $hmg_small;

  h4 { margin: 0 }
  small { opacity: .75 }
}

.hist-footer {
  margin-top: $hmg_small;
  display: flex;
  justify-content: flex-end
}

.hist-list {
  list-style: none;
  margin: 0; padding: 0;

  li {
    display: grid;
    grid-template-columns: 200px 1fr;
    gap: $mg_small;
    padding: $hmg_small 0;
    border-top: 1px solid $color-light;

    &:first-child { border-top: 0 }
  }

  .when {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .id { opacity: .7 }
  }

  .what .line {
    display: grid;
    grid-template-columns: 2fr auto;
    align-items: center;
    gap: $mg_small;
  }

  .flow {
    display: flex;
    align-items: center;
    gap: $mg_mini;
  }

  .meta {
    display: flex;
    align-items: center;
    gap: $mg_small;
    font-size: $font-size-small;
    opacity: .75;
    justify-content: center;
  }

  .tag {
    display: inline-flex; align-items: center;
    padding: 2px 10px; border-radius: 999px;
    font-size: $font-size-small; line-height: 1
  }

  .tag.status_ativo { background: rgba($color-success, .1); color: $color-success }
  .tag.status_matricula { background: rgba($color-success-2, .12); color: $color-success-2 }
  .tag.status_rematricula { background: rgba($color-alert, .12); color: $color-alert }
  .tag.status_inativo { background: rgba($color-light, .35); color: $color-dark }

  .arrow { opacity: .6 }
  .obs { margin: 6px 0 0 0 }
  .meta { margin-top: 4px; font-size: $font-size-small; opacity: .75; display: flex; gap: $mg_small }
}
</style>
